import React from 'react';
import PropTypes from 'prop-types';
import { PrintSize } from '../prop-types';
import PhotoDpiNotice from '../common/photo-quality/photo-dpi-notice';
import Currency from '../../_utils/tools/currency';
import RecommendedPrintSizeBadge from '../common/photo-quality/recommended-print-size-badge';

export function renderSizeButton({
  title,
  price,
  area,
  key,
  sizesWithPrints,
  photoDimensions,
  showLowQualityWarning,
  hideTooltip,
  crop,
  onClick,
  recommendedPrintSize,
}) {
  const isDisabled = !!(sizesWithPrints || []).find(size => size.key === key);
  const isRecommended =
    recommendedPrintSize && recommendedPrintSize.key === key;

  return (
    <button
      type="button"
      key={key}
      className="btn btn-link btn-block size-options__size"
      disabled={isDisabled}
      onClick={() => onClick(key)}>
      {showLowQualityWarning && (
        <PhotoDpiNotice
          size_area={area}
          raw_dimensions={photoDimensions}
          crop={crop}
          noText
          hideTooltip={hideTooltip}
        />
      )}
      <strong>{title}</strong> ({Currency.format(price)})
      {isDisabled && ' - Already added'}
      {isRecommended && <RecommendedPrintSizeBadge className="ml-2" />}
    </button>
  );
}

renderSizeButton.propTypes = {
  availableSizes: PropTypes.arrayOf(PrintSize),
  showLowQualityWarning: PropTypes.bool,
  onAddSize: PropTypes.func,
}.isRequired;
